import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Box, StackView, TextInput, Button, Notification, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const AddInfoForm = ({ vehicleInfo, setVehicleInfo }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    portabilityTool: { labelNote },
    assigneeSRTModal: { addButton },
    iotOrderDetailsSection: {
      vehicleInfoMessage,
      vehicleVIN,
      vehicleMake,
      vehicleModel,
      vehicleYear,
      vehicleQuantity
    }
  } = localizedStrings;

  const [dataField, setDataFields] = useState({
    vin: '',
    make: '',
    model: '',
    year: '',
    quantity: ''
  });
  const [error, setError] = useState('');

  const onAddVehicleInfo = () => {
    if (
      !(
        dataField.vin ||
        (dataField.make && dataField.model && dataField.year)
      ) ||
      !dataField.quantity
    ) {
      setError('Please enter all necessary information');
      return;
    }
    setVehicleInfo([...vehicleInfo, dataField]);
    setDataFields({
      vin: '',
      make: '',
      model: '',
      year: '',
      quantity: ''
    });
    setError('');
  };

  return (
    <StackView space={3}>
      <Notification variant={{ style: 'subtle' }}>
        <Typography variant={{ bold: true }}>{labelNote}: </Typography>
        {vehicleInfoMessage}
      </Notification>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <TextInput
          label={vehicleVIN}
          value={dataField.vin}
          onChange={(value) =>
            setDataFields({ ...dataField, vin: value })
          }
        />
        <TextInput
          label={vehicleMake}
          value={dataField.make}
          onChange={(value) =>
            setDataFields({ ...dataField, make: value })
          }
        />
        <TextInput
          label={vehicleModel}
          value={dataField.model}
          onChange={(value) =>
            setDataFields({ ...dataField, model: value })
          }
        />
        <TextInput
          label={vehicleYear}
          pattern="[0-9]{4}"
          maxLength="4"
          value={dataField.year}
          onChange={(value) =>
            setDataFields({ ...dataField, year: value })
          }
        />
        <TextInput
          label={vehicleQuantity}
          pattern="[0-9]"
          value={dataField.quantity}
          onChange={(value) =>
            setDataFields({ ...dataField, quantity: value })
          }
        />
      </div>
      <Box style={{ paddingTop: '0.5rem' }}>
        <Button onPress={onAddVehicleInfo}>{addButton}</Button>
      </Box>
      {error && (
        <Notification
          variant={{ validation: 'error' }}
          dismissible
          onExit={() => setError('')}
          copy="en"
        >
          {error}
        </Notification>
      )}
    </StackView>
  );
};

AddInfoForm.propTypes = {
  vehicleInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
  setVehicleInfo: PropTypes.func.isRequired
};

export default AddInfoForm;
